<template>
  <article
    id="tabs-controller"
    class="garage-tabs-controller"
  >
    <div class="garage-tabs-controller__wrapper">
      <div
        v-for="tab in tabs"
        :href="`#${tab.key}`"
        :key="tab.key"
        class="garage-tabs-controller__tab"
        @click="emits('update:modelValue', tab.key)"
      >
        {{ tab.text }} <span>{{ !!tab.metadata?.counter ? `(${tab.metadata.counter})` : null }}</span>
      </div>
    </div>
  </article>
</template>
  
<script setup lang="ts">
import { Tabs } from '@/models/enums';
import type { IDmComponentsItem } from '~/models/components';

interface IProps {
  tabs: IDmComponentsItem<any, Tabs>[];
  modelValue: Tabs;
}

interface IEmits {
  (name: 'update:modelValue', key: Tabs): void;
}

const props = defineProps<IProps>();

const emits = defineEmits<IEmits>();

const setScrollTabsBehaviour = () => {
  window.onscroll = () => {
    const navLi = document.getElementsByClassName('garage-tabs-controller__tab');
    const sections = document.getElementsByClassName('garage-wrapper__section');
    const tabsController = document.getElementById('tabs-controller') as HTMLElement;
    const tabsControllerHeight = tabsController?.getBoundingClientRect().height;
    let current: string | null = "";


    [...sections].forEach((section) => {
      const sectionTop = (section as HTMLElement).offsetTop;
      if (pageYOffset >= sectionTop - tabsControllerHeight) {
        current = section.getAttribute("id");
      }
    });

    [...navLi].forEach((li) => {
      if (!current) return;
      if (li.getAttribute('href') === `#${current}`) {
        li.classList.add("active");
      } else {
        li.classList.remove("active");
      }
    });
  };
};

onMounted(() => {
  setScrollTabsBehaviour();
})


</script>
  
<style lang="scss" scoped>
@import url('assets/styles/components/garage-tabs-controller.scss');
</style>